<!-- 关于云果 -->
<template>
<div class="site-content">
  <div class="site-content-page width-per-100">
    <div class="content-row">
      <div class="content-col">
      <div class="info-list-title">
        <span>推介视频</span>
      </div>
         <video class="edui-faked-video video-js" autoplay="autoplay" controls="" loop="true" width="900" height="510" src="https://gyyg.oss-cn-shenzhen.aliyuncs.com/2021-11-25/16378313835454062.mp4"></video>
      </div>
    </div>

  </div>
</div>
</template>

<script>
import ColInfoList from '../block/ColInfoList'
import ColInfoBetweenList from '../block/ColInfoBetweenList'
import ZzfwInfo1 from '../module/ZzfwInfo1'
import ZzfwInfo2 from '../module/ZzfwInfo2'
export default {
  name: 'Gyyg01',
  components: {
    'col-info-list': ColInfoList,
    'col-between-list': ColInfoBetweenList,
  },
  data() {
    return {
      msg: 'Welcome to Your Vue.js App---template',
      infoBlock1:ZzfwInfo1,
      infoBlock2:ZzfwInfo2,
      infoPage1:{list:this.Global.kjfwServiceList,total:1},
      infoPage2:{list:this.Global.kjfwServiceFlow,total:5},
    }
  },
  methods:{
    //金融服务
    kjfw_Req(params){

    },
    //服务流程
    fwlc_Req(params){

    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.width-per-100{
  width:100%;
}
.content-row{
  width:1024px;
  margin:0 auto;
}
.content-row-c1{
  width:100%;
  background:#eee;
}

.content-row-c1 .content-block{
  width:1024px;
  margin:0 auto;
  background:#eee;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Gyyg01.vue